export const NULL_TEXT = '-';
export const UTC = 'UTC';
export const KST = 'KST';
export const FIRST_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const TOAST_AUTO_HIDE_DURATION = 3000;
